module.exports = __webpack_public_path__ + "static/img/light-history.315a5fe6.png";